var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5918 12.582H23.607",
    stroke: "#2B5CAA",
    strokeWidth: 2.35913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0872 33.0283H9.43702C8.18565 33.0283 6.98554 32.5312 6.1007 31.6464C5.21585 30.7616 4.71875 29.5614 4.71875 28.3101V9.43702C4.71875 8.18565 5.21585 6.98554 6.1007 6.1007C6.98554 5.21585 8.18565 4.71875 9.43702 4.71875H28.3101C29.5614 4.71875 30.7616 5.21585 31.6464 6.1007C32.5312 6.98554 33.0283 8.18565 33.0283 9.43702V17.3008",
    stroke: "#2B5CAA",
    strokeWidth: 2.35913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 25.1632L12.5825 17.2994C14.042 15.895 15.8413 15.895 17.3008 17.2994L19.6599 19.6586",
    stroke: "#2B5CAA",
    strokeWidth: 2.35913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3107 34.5985L33.5795 29.4336C33.9026 29.1201 34.1596 28.745 34.3353 28.3305C34.5111 27.916 34.602 27.4705 34.6027 27.0203C34.6035 26.5701 34.514 26.1243 34.3396 25.7092C34.1652 25.2942 33.9094 24.9183 33.5873 24.6037C32.9301 23.961 32.0479 23.6003 31.1287 23.5985C30.2094 23.5968 29.3258 23.954 28.6662 24.5942L28.3139 24.9402L27.9632 24.5942C27.306 23.952 26.4241 23.5916 25.5053 23.5899C24.5864 23.5881 23.7032 23.9451 23.0436 24.5848C22.7204 24.8982 22.4633 25.2732 22.2874 25.6877C22.1115 26.1021 22.0204 26.5476 22.0195 26.9978C22.0187 27.448 22.108 27.8938 22.2822 28.3089C22.4565 28.7241 22.7122 29.1001 23.0341 29.4147L28.3107 34.5985Z",
    stroke: "#2B5CAA",
    strokeWidth: 2.35913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e93ea208d516653fe59502e235f2b750.svg";
export { ForwardRef as ReactComponent };